/*-----------------------------------------------------------------
- Referral program
-----------------------------------------------------------------*/

export default {
    title             : '',
    full_name         : '',
    email_address     : '',
    phone_number      : '',
    country           : '',
    message           : '',
    submit            : '',
    show_more         : '',
    submit_success_msg: '',
};
